import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';

import { CoreModule } from 'world-archery-lib';
import { BootstrapWorldRecordsComponent } from './components/bootstrap-world-records/bootstrap-world-records.component';
import { FiltersWorldRecordsComponent } from './components/filters-world-records/filters-world-records.component';
import { WorldRecordsDetailComponent } from './components/world-records-detail/world-records-detail.component';
import { WorldRecordsItemComponent } from './components/world-records-item/world-records-item.component';
import { WorldRecordsListComponent } from './components/world-records-list/world-records-list.component';
import { FiltersWorldRecordsService } from './services/filters-world-records.service';
import { WorldRecordsRoutingModule } from './world-records-routing.module';
import { WorldRecordsBrokenPanelComponent } from './components/world-records-broken-panel/world-records-broken-panel.component';
import { VersionService } from '../version.service';
import { MODULE_VERSION } from '../token.version';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  bootstrap: [BootstrapWorldRecordsComponent],
  imports: [CommonModule, WorldRecordsRoutingModule, CoreModule, CommonPageComponentsModule],
  declarations: [
    FiltersWorldRecordsComponent,
    BootstrapWorldRecordsComponent,
    WorldRecordsListComponent,
    WorldRecordsItemComponent,
    WorldRecordsDetailComponent,
    WorldRecordsBrokenPanelComponent
  ],
  providers: [FiltersWorldRecordsService]
})
export class WorldRecordsModule {
  constructor() {

  }
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WorldRecordsModule,
      providers: [{ provide: MODULE_VERSION, useValue: new WorldRecordsModule().constructor.name }, VersionService]
    };
  }
}
